































































































































import { deepCopy } from "deep-copy-ts";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import { PostModel, PostsApi } from "../../../apis";

@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class AdminEditAboutUs extends Vue {
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  about: PostModel = Object.assign({});
  errorEn = "";
  errorVi = "";
  editorConfig = {
    extraPlugins: "colorbutton,colordialog,font,justify",
  };
  editorConfig2 = {
    extraPlugins: "colorbutton,colordialog,font,justify",
  };
  ckeditorEnLoaded = false;

  created() {
    this.getAbout();
  }

  onCancel() {
    this.$router.push({ name: "about" });
  }

  @Watch("about.contentEn")
  onContentEnWatch(val) {
    this.errorEn = "";
  }

  @Watch("about.contentVn")
  onContentVnWatch(val) {
    this.errorVi = "";
  }

  async onReview() {
    let pass = true;
    if (
      (this.$refs["ckeditorEn"] as any).instance.document
        .getBody()
        .getText() === "\n"
    ) {
      pass = false;
      this.errorEn = this.$t("message.required").toString();
    }
    if (
      (this.$refs["ckeditorVi"] as any).instance.document
        .getBody()
        .getText() === "\n"
    ) {
      pass = false;
      this.errorVi = this.$t("message.required").toString();
    }
    const valid = await this.observer.validate();
    if (!valid || !pass) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$store.commit("SET_ABOUT", this.about);
    this.$router.push({ name: "review-edit-about" });
  }

  async getAbout() {
    const from = this.$route.query.from as string;
    if (from === 'review') {
      this.about = deepCopy(this.$store.getters.about);
    } else {
      const res = await new PostsApi().getAboutPost();
      if (!this.lodash.isEmpty(res.data.data)) {
        this.about = res.data.data[0];
      }
    }
  }

  async updateAbout() {
    let pass = true;
    if (
      (this.$refs["ckeditorEn"] as any).instance.document
        .getBody()
        .getText() === "\n"
    ) {
      pass = false;
      this.errorEn = this.$t("message.required").toString();
    }
    if (
      (this.$refs["ckeditorVi"] as any).instance.document
        .getBody()
        .getText() === "\n"
    ) {
      pass = false;
      this.errorVi = this.$t("message.required").toString();
    }
    const valid = await this.observer.validate();
    if (!valid || !pass) {
      return;
    }
    try {
      this.$util.showLoading();
      await new PostsApi().updatePost({
        id: this.about.id,
        putPostRequest: {
          subjectEn: this.about.subjectEn,
          headerUrlEn: this.about.headerUrlEn,
          headerUrlVn: this.about.headerUrlVn,
          shortDescriptionEn: "",
          subjectVn: this.about.subjectVn,
          shortDescriptionVn: "",
          contentVn: (this.$refs["ckeditorVi"] as any).instance.document
            .getBody()
            .getHtml(),
          contentEn: (this.$refs["ckeditorEn"] as any).instance.document
            .getBody()
            .getHtml(),
          isAbout: true,
          id: this.about.id,
        },
      });
      this.$router.push({ name: "about" });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
